fabric.StaticCanvas.prototype.dispose = (function A() {
    return function B() {}
})(fabric.StaticCanvas.prototype.dispose)
